import {
    LIST_PROCEEDING_HISTORY,
    LIST_PROCEEDING_HISTORY_ERROR,
    LIST_PROCEEDING_HISTORY_SUCCESS,
    LIST_PROCEEDINGS,
    LIST_PROCEEDINGS_ERROR,
    LIST_PROCEEDINGS_SUCCESS,
    SELECT_HISTORY,
    SELECT_HISTORY_SUCCESS,
    SELECT_HISTORY_ERROR,
    UNSELECT_HISTORY,
    UNSELECT_HISTORY_SUCCESS,
    LIST_JURISDICTIONS,
    LIST_JURISDICTIONS_SUCCESS,
    LIST_JURISDICTIONS_ERROR,
    SELECT_JURISDICTIONS,
    CLOSE_JURISDICTION_LIST,
    CLOSE_JURISDICTION_LIST_SUCCESS,
    GET_JURISDICTION,
    GET_JURISDICTION_SUCCESS,
    GET_JURISDICTION_ERROR,
    UNSELECT_JURISDICTION,
    UNSELECT_JURISDICTION_SUCCESS,
    DECODE_URL,
    DECODE_URL_SUCCESS,
    DECODE_URL_ERROR
} from '../types';

import api from '../helpers/api';
import alertMessages from '../helpers/alertMessages';
import messages from '../constants/messages';
import apiMethods from '../constants/apiMethods';
import routes from '../constants/routes';

import { getApiPrefix } from '../helpers/authHelper';

//LISTAR CATEGORIAS
export function listJurisdictionsAction(center) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listJurisdictions() );
        //Ejecuto la consulta
        try{
            //Inicializo el query
            let query = '';
            //Me fijo si hay filtro
            if(center){
                query = '?center=' + center.id + '&full=1';
            }
            //Hago la consulta
            const response = await api.get(`${getApiPrefix()}${apiMethods.JURISDICTIONS}${query}`);
            //Obtengo los datos
            const { data } = response.data;
            //Llamo al dispatch
            dispatch( listJurisdictionsSuccess({
                center,
                jurisdictions: data
            }) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listJurisdictionsError(data) );
            //Oculto espera
            alertMessages.error(data.message);
        }
    }
}

const listJurisdictions = () => ({
    type: LIST_JURISDICTIONS,
    payload: true
});

const listJurisdictionsSuccess = centers => ({
    type: LIST_JURISDICTIONS_SUCCESS,
    payload: centers
});

const listJurisdictionsError = error => ({
    type: LIST_JURISDICTIONS_ERROR,
    payload: error
});

//SELECT JURISDICTIONS
export function selectJurisdictionsAction(jurisdiction, history) {
    return (dispatch) => {
        //Inicializo
        dispatch( selectJurisdictions(jurisdiction) );
        //Una vez seleccionado, redirecciono
        history.push(routes.SEARCH(jurisdiction.slug));
    }
}

const selectJurisdictions = jurisdiction => ({
    type: SELECT_JURISDICTIONS,
    payload: jurisdiction
});

//CERRAR LISTADO DE FUEROS
export function closeJurisdictionsListAction() {
    return async (dispatch) => {
        //Inicializo
        dispatch( closeJurisdictionsList() );
        //Ejecuto operación
        dispatch( closeJurisdictionsListSuccess() );
    }
}

const closeJurisdictionsList = () => ({
    type: CLOSE_JURISDICTION_LIST,
    payload: true
});

const closeJurisdictionsListSuccess = () => ({
    type: CLOSE_JURISDICTION_LIST_SUCCESS,
    payload: null
});

//OBTENER FUERO Y UNIDADES
export function getJurisdictionAction(slug) {
    return async (dispatch) => {
        //Inicializo
        dispatch( getJurisdiction() );
        //Ejecuto la consulta
        try{
            //Hago la consulta
            const response = await api.get(`${apiMethods.JURISDICTIONS_SLUG}?slug=${slug}&full=1`);
            //Obtengo los datos
            const { data } = response.data;
            //Llamo al dispatch
            dispatch( getJurisdictionSuccess(data) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( getJurisdictionError(data) );
            //Error
            alertMessages.error(data.message);
        }
    }
}

const getJurisdiction = () => ({
    type: GET_JURISDICTION,
    payload: true
});

const getJurisdictionSuccess = data => ({
    type: GET_JURISDICTION_SUCCESS,
    payload: data
});

const getJurisdictionError = error => ({
    type: GET_JURISDICTION_ERROR,
    payload: error
});

//LISTAR PROCESOS
export function listProceedingsAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listProceedings() );
        //Ejecuto la consulta
        try{
            //Hago la consulta
            const response = await api.get(`${getApiPrefix()}${apiMethods.PROCEEDING}`, { params });
            //Obtengo los datos
            const res = response.data;
            //Llamo al dispatch
            dispatch( listProceedingsSuccess({
                params,
                proceedings: res.data
            }) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listProceedingsError(data) );
            //Mensaje de error
            alertMessages.error(data.message);
        }
    }
}

const listProceedings = () => ({
    type: LIST_PROCEEDINGS,
    payload: true
});

const listProceedingsSuccess = data => ({
    type: LIST_PROCEEDINGS_SUCCESS,
    payload: data
});

const listProceedingsError = error => ({
    type: LIST_PROCEEDINGS_ERROR,
    payload: error
});


//LISTAR HISTORIA
export function listHistoryAction(proceeding, history) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listHistory(proceeding) );
        //Ejecuto la consulta
        try{
            //Hago la consulta
            const response = await api.get(
                `${getApiPrefix()}${apiMethods.HISTORY}?jurisdiction=${proceeding.jurisdiction_id}&proceeding=${proceeding.procid}`
            );
            //Obtengo los datos
            const res = response.data;
            //Llamo al dispatch
            dispatch( listHistorySuccess(res.data) );
            //Debo redireccionar
            history.push(
                `${routes.HISTORY(proceeding.jurisdiction_slug, encodeURIComponent(proceeding.nro_expediente))}${ proceeding.histid ? `?v=${proceeding.histid}` : '' }`
            );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listHistoryError(data) );
            //Mensaje de error
            alertMessages.error(data.message);
        }
    }
}

const listHistory = proceeding => ({
    type: LIST_PROCEEDING_HISTORY,
    payload: proceeding
});

const listHistorySuccess = stories => ({
    type: LIST_PROCEEDING_HISTORY_SUCCESS,
    payload: stories
});

const listHistoryError = error => ({
    type: LIST_PROCEEDING_HISTORY_ERROR,
    payload: error
});

//SELECT HISTORY
export function selectHistoryAction(proceeding, story) {
    return async (dispatch) => {
        //Inicializo
        dispatch( selectHistory(proceeding, story) );
        //Ejecuto
        try{
            //Armo el query
            const response = await api.get(
                `${getApiPrefix()}/proceedings/history/text?jurisdiction=${proceeding.jurisdiction_id}&proceeding=${proceeding.procid}&history=${story.histid}`
            );
            //Obtengo los datos
            const res = response.data;
            //Llamo al dispatch
            dispatch(selectHistorySuccess(res.data));
        }catch(error){
            const errorResponse = error.response;
            let errorData = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(errorResponse){
                errorData = errorResponse.data;
            }
            //Llamo al dispatch
            dispatch(selectHistoryError(errorData));
            //Error
            alertMessages.error(errorData.message);
        }
    }
}

const selectHistory = proceeding => ({
    type: SELECT_HISTORY,
    payload: proceeding
});

const selectHistorySuccess = stories => ({
    type: SELECT_HISTORY_SUCCESS,
    payload: stories
});

const selectHistoryError = error => ({
    type: SELECT_HISTORY_ERROR,
    payload: error
});

//UNSELECT HISTORY
export function unselectHistoryAction() {
    return async (dispatch) => {
        //Inicializo
        dispatch( unselectHistory() );
        //Llamo al dispatch
        dispatch(unselectHistorySuccess());
    }
}

const unselectHistory = () => ({
    type: UNSELECT_HISTORY,
    payload: true
});

const unselectHistorySuccess = () => ({
    type: UNSELECT_HISTORY_SUCCESS,
    payload: null
});

//UNSELECT JURISDICTIONS
export function unselectJurisdictionAction() {
    return async (dispatch) => {
        //Inicializo
        dispatch( unselectJurisdiction() );
        //Llamo al dispatch
        dispatch(unselectJurisdictionSuccess());
    }
}

const unselectJurisdiction = () => ({
    type: UNSELECT_JURISDICTION,
    payload: true
});

const unselectJurisdictionSuccess = () => ({
    type: UNSELECT_JURISDICTION_SUCCESS,
    payload: null
});

//DECODE URL
export function decodeUrlAction(code, history) {
    return async (dispatch) => {
        //Inicializo
        dispatch( decodeUrl() );
        //Ejecuto la consulta
        try{
            //Hago la consulta
            const response = await api.post(`${getApiPrefix()}${apiMethods.DECODE_URL}`, {
                code
            });
            //Obtengo los datos
            const res = response.data;
            //Llamo al dispatch
            dispatch( decodeUrlSuccess(res.data) );
            //Tomo el proceeding
            const proceeding = res.data.proceeding;
            const proceedingHistory = res.data.history;
            //Debo redireccionar
            history.push(
                `${routes.HISTORY(proceeding.jurisdiction_slug, encodeURIComponent(proceeding.nro_expediente))}${ proceedingHistory ? `?v=${proceedingHistory.histid}` : '' }`
            );
        }catch(error){
            console.log(error);
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( decodeUrlError(data) );
            //Mensaje de error
            alertMessages.error(data.message);
        }
    }
}

const decodeUrl = proceeding => ({
    type: DECODE_URL,
    payload: proceeding
});

const decodeUrlSuccess = stories => ({
    type: DECODE_URL_SUCCESS,
    payload: stories
});

const decodeUrlError = error => ({
    type: DECODE_URL_ERROR,
    payload: error
});